import {Fragment, h} from 'preact';
import Device from './Device';


export default function DeviceList({devices, formParams}){
	return (
		<div className="account-details">
			{devices.map(deviceInfo => (
				<Device deviceInfo={deviceInfo} formParams={formParams} />
			))}
		</div>
	)
}
